import list from './list/reducer';
import users from './users/reducer';
import single from './single/reducer';
import data from './data/reducer';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  single,
  users,
  data,
});
